export default defineAppConfig({
  ui: {
    colors: {
      primary: "blue",
      neutral: "zinc",
    },
    button: {
      base: "cursor-pointer", // Add cursor-pointer to base class
    },
    radioGroup: {
      base: "cursor-pointer",
      slots: {
        item: "p-2 rounded cursor-pointer text-red-500 light:hover:bg-gray-50 dark:hover:bg-gray-900",
        description: "text-sm",
      },
    },
    formField: {
      slots: {
        root: "mb-4"
      }
    },
  },
});
